import * as React from 'react';
import { RadioButtonGroup, UiKitRoot } from '@cian/ui-kit';

import { useAddressCadastreField, useAddressSuggest, useCadastreInput } from './utils';
import { CadastreInput } from './components/CadastreInput';
import { AddressSuggest } from './components/AddressSuggest';
import { ADDRESS_CADASTRAL_FIELD_TEST_ID, INPUT_MODE_OPTIONS } from './const';
import { EInputMode, IAddressCadastreFieldContainerProps } from './types';
import { useAddressCadastreCustomError } from './utils/useAddressCadastreCustomError';

import * as styles from './styles.css';

export const AddressCadastreFieldContainer: React.FC<IAddressCadastreFieldContainerProps> = ({ name }) => {
  const { value, touched, error, onCadastreChange, onAddressChange, onBlur, inputMode, onInputModeChange } =
    useAddressCadastreField({ name });

  const errors = useAddressCadastreCustomError({
    error,
    inputMode,
    onInputModeChange,
  });

  const addressSuggestProps = useAddressSuggest({
    value: value?.address || null,
    error: touched && errors.address ? errors.address : undefined,
    onChange: onAddressChange,
    onBlur,
  });

  const cadastreInputProps = useCadastreInput({
    value: value?.cadastre || null,
    error: touched && errors.cadastre ? errors.cadastre : undefined,
    onChange: onCadastreChange,
    onBlur,
  });

  const inputModeChangeHandler = React.useCallback<(e: React.ChangeEvent<HTMLInputElement>, value: EInputMode) => void>(
    (e, value) => {
      onInputModeChange(value);
    },
    [onInputModeChange],
  );

  // UiKitContext переопределяется для использования
  // мобильного отображения RadioButtonGroup (больше по размеру)
  return (
    <div data-testid={ADDRESS_CADASTRAL_FIELD_TEST_ID}>
      <div className={styles['input-mode-select-area']}>
        <UiKitRoot deviceType="phone" useStaticDeviceType>
          <RadioButtonGroup value={inputMode} options={INPUT_MODE_OPTIONS} onChange={inputModeChangeHandler} />
        </UiKitRoot>
      </div>
      {inputMode === EInputMode.Address && <AddressSuggest {...addressSuggestProps} />}
      {inputMode === EInputMode.Cadastre && <CadastreInput {...cadastreInputProps} />}

      {touched && errors.custom && <div className={styles['alert-area']}>{errors.custom}</div>}
    </div>
  );
};

AddressCadastreFieldContainer.displayName = 'AddressCadastreFieldContainer';
